import validate from 'validate.js';

import Api from '../api';
import getValidations from '../validations';
import { RequiredPaymentMethodFields } from '../';

import { objectPropsToCamelCase } from '~/lib/utils/api';

export const updateAmounts = ({ commit, state }) => {
  commit('setValidDiscountCode', { valid: false });

  return new Promise((resolve, reject) => {
    Api.getAmounts(
      state.product.id,
      state.orderBump && state.orderBump.checked,
      state.orderQuantity,
      state.discountCode,
      state.amountsUrl
    ).then((response) => {
      const {
        singlePayment: singlePaymentAmounts,
        firstRecurrencePayment: firstRecurrencePaymentAmounts,
        recurrencePayment: recurrencePaymentAmounts
      } = objectPropsToCamelCase(response.data.amounts);

      const amounts = {
        singlePayment: getFirstPaymentAmounts(singlePaymentAmounts),
        firstRecurrencePayment: firstRecurrencePaymentAmounts &&
                                  getFirstPaymentAmounts(firstRecurrencePaymentAmounts),
        recurrencePayment: recurrencePaymentAmounts &&
                            getRecurrencePaymentAmounts(recurrencePaymentAmounts)
      };

      commit('setAmounts', { amounts });
      commit('setValidDiscountCode', { valid: response.data.discounted });

      resolve({ valid: response.data.discounted });
    }).catch((error) => {
      reject(error);
    });
  });
};

const getFirstPaymentAmounts = (paymentAmounts) => {
  return {
    product: {
      amountIncVat: paymentAmounts.product.amountIncVat,
      amountExVat: paymentAmounts.product.amountExVat
    },
    orderBump: {
      amountExVat: paymentAmounts.orderBump.amountExVat
    },
    vat: {
      amount: paymentAmounts.vat.amount
    },
    discountedProduct: {
      amountIncVat: paymentAmounts.discountedProduct.amountIncVat,
      amountExVat: paymentAmounts.discountedProduct.amountExVat
    },
    discountedTotal: {
      amountIncVat: paymentAmounts.discountedTotal.amountIncVat,
      amountExVat: paymentAmounts.discountedTotal.amountExVat
    },
    total: {
      amountIncVat: paymentAmounts.total.amountIncVat,
      amountExVat: paymentAmounts.total.amountExVat
    }
  };
};

const getRecurrencePaymentAmounts = (paymentAmounts) => {
  return {
    product: {
      amountExVat: paymentAmounts.product.amountExVat
    },
    vat: {
      amount: paymentAmounts.vat.amount
    },
    discountedTotal: {
      amountIncVat: paymentAmounts.discountedTotal.amountIncVat,
      amountExVat: paymentAmounts.discountedTotal.amountExVat
    },
    total: {
      amountIncVat: paymentAmounts.total.amountIncVat,
      amountExVat: paymentAmounts.total.amountExVat
    }
  };
};

export const setPspDisabled = ({ commit, state, dispatch }, { code, value }) => {
  commit('setPspDisabled', { code, value });

  if (value && state.selectedPspCode === code) {
    const availablePsps = state.psps.filter((psp) => psp.code !== code);

    dispatch('setSelectedPspCode', {
      code:  availablePsps.length ? availablePsps[0].code : null
    });
  }
};

export const setSelectedPspCode = ({ commit, state }, { code }) => {
  commit('setSelectedPspCode', { code });

  Object.keys(state.inputs).forEach((name) => {
    commit('setInputError', { name, value: null });
  });
};

export const validateField = ({ commit, state }, inputKey) => {
  if (!state.inputs[inputKey]) { return; }

  const { value } = state.inputs[inputKey];
  let results;

  let optional = state.optional[inputKey] && !RequiredPaymentMethodFields[state.selectedPspCode]?.includes(inputKey);

  const validations = getValidations({ optional });

  if (inputKey === 'passwordConfirmation') {
    const attributes = { password: state.inputs['password'].value, passwordConfirmation: value };
    results = validate(
      attributes,
      { passwordConfirmation: validations[inputKey] },
      { fullMessages: false }
    )?.passwordConfirmation;
  } else if (inputKey === 'phoneno' && state.selectedPspCode == 'afterpay') {
    results = validate.single(value, validations['afterpayPhoneno']);
  } else if (inputKey === 'email') {
    results = validate.single(value?.trim(), validations[inputKey]);
  } else {
    results = validate.single(value, validations[inputKey]);
  }

  commit('setInputError', {
    name: inputKey,
    value: results?.[0] || null
  });
};
